import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { Slot } from 'src/app/beans/slot/slot.bean';
import { SlotVisibility } from 'src/app/beans/slot/slot.visibility.bean';
import { Result } from 'src/app/beans/result/result.bean';

@Component
({
  selector: 'slot-dialog',
  templateUrl: './slot.dialog.html',
  styleUrls: ['./slot.dialog.scss'],
})

export class SlotDialog implements OnInit 
{
  private date: string

  private hour  : string
  private minute: string

  _time : any
  slot  : Slot
  serviceId: number
  
  visibilities      : SlotVisibility[]
  selectedVisibility: number

  constructor
    (
      private dialogRef: MatDialogRef<SlotDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,

      private _handler: HandlerManager,
      private _loader: LoadingManager,
      private _session: SessionManager,
  ) { }

  ngOnInit(): void 
  {
    this.date         = this.data.date
    this.visibilities = this.data.visibilities
    this.serviceId    = this.data.serviceId

    if(this.data.slot)
    {
      this.slot  = this.data.slot
      this._time = this.slot.timeBegin
      this.convertTime()
    }
  }

  //---------------------------------------------------------------------------------------------------

  async create() 
  {
    this.formatTime()

    let response = null
    if(this._time) response = await this.changeValue(this.hour + ":" + this.minute + ":00")    
    else           response = await this.changeValue(null)

    this.acceptOperation(response)
  }

  async update() 
  {
    this.formatTime()

    let response = null
    if(this._time) response = await this.updateSlot(this.hour + ":" + this.minute + ":00")    
    else           response = await this.updateSlot(null)

    this.acceptOperation(response)
  }

  acceptOperation(response: any)
  {
    if(Result.isKind(response) && response.result == 1)
    {
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.SLOT_OPERATION_ACCEPTED
        }
      )
    }
  }

  cancel() {
    this.dialogRef.close
      (
        {
          code: DialogsReturnCode.OPERATION_DECLINED
        }
      )
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue(time:string) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return

    this._loader.start()

    let response = null
    response = await this._handler.slot().create((user as User).token, this.serviceId, this.date, time, this.selectedVisibility)

    this._loader.stop()

    return response
  }

  async updateSlot(time:string) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return

    this._loader.start()

    let response = null
    response = await this._handler.slot().update((user as User).token, this.serviceId, this.slot.id, this.date, time, this.selectedVisibility)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------

  visibilityChange(el: any)
  {
    this.selectedVisibility = el.id
  }

  convertTime()
  {
    const timesArray = this.slot.timeBegin.split(":").map((time) => +time);
    const model = 
    {
      hour: timesArray[0],
      minute: timesArray[1]
    }

    this._time = model
  }

  formatTime() 
  {
    if ( this._time ) 
    {
      this.hour    = this._time.hour
      this.minute  = this._time.minute

      if (this._time.hour < 10) {
        this.hour = "0" + this._time.hour
      }

      if (this._time.minute < 10) {
        this.minute = "0" + this._time.minute
      }
    }
  }

  getSlotSameDayBook()
  {
    if(this.slot) return this.slot.sameDayBook
    return -1
  }
}
